<template>
  <div class="ai-chat-message-image">
    <div class="mb-3">{{ text }}</div>
    <div class="img-container flex">
      <img :src="item.image" @click="openLightbox" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
    },
  },
  data() {
    return {
      lightbox: {
        name: '',
        src: '',
        isShow: false,
      },
    };
  },
  watch: {},
  computed: {
    item() {
      return this.message.content[0];
    },
    text() {
      const { garment_size: size, user_size: pairedSize } = this.item.data;
      return size === pairedSize
        ? this.$t('chat.try_on_result', { msg: size })
        : this.$t('chat.size', { msg: size });
    },
  },
  methods: {
    openLightbox() {
      this.$emit('on-image-click', this.message.msg_id);
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-chat-message-image {
  padding: 16px;
  color: #fff;
  font-feature-settings: 'dlig' on;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  gap: 8px;
  overflow-x: auto;

  .img-container {
    img {
      max-width: 100%;
      height: 250px;
    }
  }
}
</style>
